import React from "react";
import {
  ArrowUp,
  ArrowDown,
  Minus,
  Dumbbell,
  Wheat,
  Droplet,
  Beef,
  HeartPulse,
  Flame,
} from "lucide-react";

export function Avocado({ className, style }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      style={style}
    >
      <path d="M12 21c-3.9 0-6.2-3.3-6.2-6.9 0-4.6 3-11.1 6.2-11.1s6.2 6.5 6.2 11.1C18.2 17.7 15.9 21 12 21Z" />
      <circle cx="12" cy="14.2" r="2.7" />
    </svg>
  );
}

export const METRIC_ICONS = {
  activity: Dumbbell,
  carbs: Wheat,
  fat: Avocado,
};

export const METRIC_LABELS = {
  activity: "Movement",
  carbs: "Carbs",
  fat: "Fats",
};

export function directionMeta(direction) {
  if (direction === "increase")
    return { Icon: ArrowUp, color: "#2E7D32", bg: "#E5F0E4", word: "Increase" };
  if (direction === "reduce")
    return { Icon: ArrowDown, color: "#9B3926", bg: "#F5E3DE", word: "Reduce" };
  return { Icon: Minus, color: "#B0872F", bg: "#F6ECD6", word: "Maintain" };
}

export function focusMeta(focus) {
  if (focus === "fitness")
    return { Icon: Flame, label: "Fitness Window", color: "#839788" };
  return { Icon: HeartPulse, label: "Hormone Care", color: "#9B3926" };
}

// small 3-dot level indicator
export function LevelDots({ level, color = "#2D2A26", testid }) {
  return (
    <div className="flex items-center gap-1" data-testid={testid}>
      {[1, 2, 3].map((n) => (
        <span
          key={n}
          className="h-1.5 w-4 rounded-full transition-colors"
          style={{ backgroundColor: n <= level ? color : "#E5DFD3" }}
        />
      ))}
    </div>
  );
}

export { Droplet, Beef };
